

























import {Component, Vue, Mixins, Prop} from "vue-property-decorator";
import { User } from "../../services/auth.service";
import { BlogPostListing } from "../../services/blog.service";
import Indicator from "@/components/ui/Indicator.vue";


@Component({
    components: {
        Indicator,
    }
})
export default class BlogTable extends Vue {
    @Prop()
    public list!: BlogPostListing[];
}
